import React, { Component } from "react";
import { Result } from "antd";
import { GetData } from "../api/service";

/**
 * Shows its children only while the service is switched on in superadmin.
 *
 * If the settings cannot be loaded the children still render: the API refuses
 * the request itself when a service is off, so this is only the friendly view.
 */
export default class ServiceGate extends Component {
  state = { isLoaded: false, isOpen: true };

  componentDidMount() {
    GetData("/getportalsettings")
      .then((settings) => {
        this.setState({
          isLoaded: true,
          isOpen: settings[this.props.service] !== false
        });
      })
      .catch(() => {
        this.setState({ isLoaded: true });
      });
  }

  render() {
    if (!this.state.isLoaded) {
      return <div>Loading . . . Please wait</div>;
    }

    if (!this.state.isOpen) {
      return (
        <Result
          status="warning"
          title="Service currently unavailable"
          subTitle="This service is closed for now. Please contact the college office."
        />
      );
    }

    return this.props.children;
  }
}
